var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState, useRef, useCallback } from "react";
import Card from "../../atoms/card/card";
import NavBar from "../../organisms/navBar/navBar";
import PageHeader from "../../organisms/pageHeader/pageHeader";
import LoadingOverlay from "../../atoms/loadingOverlay/loadingOverlay";
import "../../templates/general_page_template.css";
import "../../molecules/tabs/tabs.css";
import Button from "../../atoms/button/button";
import { ButtonType } from "../../atoms/button/buttonType";
import GenericTab from "../../molecules/genericTab/genericTab";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import TableCard from "../../molecules/table/table";
import { getCaseloads, getCaseloadsDashboard, exportUsersData, archiveUsersData, deleteUsersData, forceBlrRecalculation, } from "../../../redux/actions/manage_users";
import showPopupModal from "../../../redux/actions/popupModal";
import CreateUser from "../../organisms/createUser/CreateUser";
import ManageUsersStats from "./manageUsersStats";
import ErrorMessage from "../../atoms/errorMessage/errorMessage";
import { Status } from "../../../redux/constants/status";
import PendingInvites from "../../organisms/pendingInvites/PendingInvites";
function prepareForTable(caseload, userType, tab) {
    // DOES NOT REMEMBER BETWEEN TABS
    // possible fix: prepare them beforehand
    switch (userType) {
        case "adviser":
            return prepareJobseeker(caseload, userType);
        case "manager":
            if (tab === 0) {
                return prepareAdviser(caseload);
            }
            else {
                return prepareJobseeker(caseload, userType);
            }
        case "superorg":
            if (tab === 0) {
                return prepareOrganisation(caseload);
            }
            else if (tab === 1) {
                return prepareManager(caseload);
            }
            else if (tab === 2) {
                return prepareAdviser(caseload);
            }
            else {
                return prepareJobseeker(caseload, userType);
            }
        case "organisation":
        default:
            if (tab === 0) {
                return prepareManager(caseload);
            }
            else if (tab === 1) {
                return prepareAdviser(caseload);
            }
            else {
                return prepareJobseeker(caseload, userType);
            }
    }
}
function prepareJobseeker(caseload, userType) {
    var _a;
    var res = [];
    try {
        (_a = caseload === null || caseload === void 0 ? void 0 : caseload.jobseekers) === null || _a === void 0 ? void 0 : _a.forEach(function (js) {
            var _a;
            try {
                var blrDisplay = "";
                if (userType !== "adviser") {
                    // Format BLR score or reason
                    if (typeof js.blr_score === "string" && !js.blr_score.endsWith("%")) {
                        // It's an error message
                        blrDisplay = {
                            text: "No prediction",
                            tooltip: js.blr_score,
                            type: "tooltip",
                        };
                    }
                    else if (js.blr_score) {
                        var scoreValue = typeof js.blr_score === "string"
                            ? parseFloat(js.blr_score.replace("%", ""))
                            : js.blr_score;
                        blrDisplay = "".concat(Math.round(scoreValue), "%");
                    }
                    else {
                        blrDisplay = "No data";
                    }
                }
                res.push(__spreadArray(__spreadArray([
                    false,
                    js.name || "",
                    js.dateJoined || "",
                    "".concat((js.questionnaire_attempts || 0).toString(), " / ").concat(js.questionnaire_attempts_total || 2),
                    js.timegap === 0 ? " - " : "".concat(((_a = js.timegap) === null || _a === void 0 ? void 0 : _a.toString()) || "0", " Days")
                ], (userType !== "adviser" ? [blrDisplay] : []), true), [
                    js.employed ? js.employed.toString() : "-",
                    js.wellbeing_score_q1 !== null && js.wellbeing_score_q1 !== undefined
                        ? js.wellbeing_score_q1.toString()
                        : " - ",
                    js.wellbeing_score_q2 !== null && js.wellbeing_score_q2 !== undefined
                        ? js.wellbeing_score_q2.toString()
                        : " - ",
                    js.questionnaire_attempts === 0
                        ? "No Questionnaires attempted"
                        : {
                            link: "/dashboard",
                            text: "View Dashboard >",
                            state: { state: { viewUser: js.name } },
                            type: "link",
                        },
                ], false));
            }
            catch (error) {
                console.error("Error processing jobseeker:", error, js);
            }
        });
    }
    catch (error) {
        console.error("Error processing caseload:", error);
    }
    return res;
}
function prepareAdviser(caseload) {
    var res = [];
    caseload
        ? caseload.advisers &&
            caseload.advisers.forEach(function (js) {
                res.push([
                    false,
                    js.name,
                    js.dateJoined,
                    js.caseload.toString(),
                    {
                        link: "/dashboard",
                        text: "View Dashboard >",
                        state: { state: { viewUser: js.name } },
                        type: "link",
                    },
                ]);
            })
        : undefined;
    return res;
}
function prepareManager(caseload) {
    var res = [];
    caseload
        ? caseload.managers &&
            caseload.managers.forEach(function (js) {
                res.push([
                    false,
                    js.name,
                    js.dateJoined,
                    js.adviser_number.toString(),
                    js.caseload.toString(),
                    {
                        link: "/dashboard",
                        text: "View Dashboard >",
                        state: { state: { viewUser: js.name } },
                        type: "link",
                    },
                ]);
            })
        : undefined;
    return res;
}
function prepareOrganisation(caseload) {
    var res = [];
    caseload
        ? caseload.organisations &&
            caseload.organisations.forEach(function (org) {
                res.push([
                    false,
                    org.name,
                    org.dateJoined,
                    org.manager_number.toString(),
                    org.adviser_number.toString(),
                    org.caseload.toString(),
                    {
                        link: "/dashboard",
                        text: "View Dashboard >",
                        state: { state: { viewUser: org.name } },
                        type: "link",
                    },
                ]);
            })
        : undefined;
    return res;
}
function prepareHeader(userType, tab) {
    switch (userType) {
        case "adviser":
            return [
                "",
                "Name",
                "Date Joined",
                "Questionnaire Attempts",
                "Time gap",
                "Employment Status",
                "Wellbeing Q1",
                "Wellbeing Q2",
                "",
            ];
        case "manager":
            if (tab === 0) {
                return ["", "Name", "Date Joined", "Advising", ""];
            }
            else {
                return [
                    "",
                    "Name",
                    "Date Joined",
                    "Questionnaire Attempts",
                    "Time gap",
                    "Prediction",
                    "Employment Status",
                    "Wellbeing Q1",
                    "Wellbeing Q2",
                    "",
                ];
            }
        case "superorg":
            if (tab === 0) {
                return [
                    "",
                    "Name",
                    "Date Joined",
                    "Managers",
                    "Advisers",
                    "Jobseekers",
                    "",
                ];
            }
            else if (tab === 1) {
                return ["", "Name", "Date Joined", "Advising", "Jobseekers", ""];
            }
            else if (tab === 2) {
                return ["", "Name", "Date Joined", "Advising", ""];
            }
            else {
                return [
                    "",
                    "Name",
                    "Date Joined",
                    "Questionnaire Attempts",
                    "Time gap",
                    "Prediction",
                    "Employment Status",
                    "Wellbeing Q1",
                    "Wellbeing Q2",
                    "",
                ];
            }
        case "organisation":
        default:
            if (tab === 0) {
                return ["", "Name", "Date Joined", "Advising", "Jobseekers", ""];
            }
            else if (tab === 1) {
                return ["", "Name", "Date Joined", "Jobseekers", ""];
            }
            else {
                return [
                    "",
                    "Name",
                    "Date Joined",
                    "Questionnaire Attempts",
                    "Time gap",
                    "Prediction",
                    "Employment Status",
                    "Wellbeing Q1",
                    "Wellbeing Q2",
                    "",
                ];
            }
    }
}
export default function ManageUsers() {
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var state = useLocation().state;
    var userToken = useSelector(function (state) { return state.rootReducer.userReducer.loginData; });
    var username = useSelector(function (state) { return state.rootReducer.dashboardReducer.viewing_username; });
    var safeUser = useSelector(function (state) { return state.rootReducer.userReducer.username; });
    username = username ? username : safeUser;
    var logged_in_user_type = useSelector(function (state) { return state.rootReducer.dashboardReducer.logged_in_user_type; });
    var isSuperOrg = logged_in_user_type === "superorg";
    var viewing_user_type = useSelector(function (state) { return state.rootReducer.dashboardReducer.viewing_user_type; });
    var safe_viewing_usertype = useSelector(function (state) { return state.rootReducer.userReducer.userType; });
    viewing_user_type = viewing_user_type
        ? viewing_user_type
        : safe_viewing_usertype;
    var caseload = useSelector(function (state) { return state.rootReducer.ManageUserReducer.caseload; });
    var isLoading = useSelector(function (state) { return state.rootReducer.ManageUserReducer.status === "Loading"; });
    var createUserStatus = useSelector(function (state) { return state.rootReducer.ManageUserReducer.createUserStatus; });
    var deleteUsersResult = useSelector(function (state) { return state.rootReducer.ManageUserReducer.manageDeleteUsers; });
    // Get the current viewing user from state or fallback to logged-in user
    var currentViewingUser = state && state.viewUser ? state.viewUser : username;
    // Get the currently displayed username to detect if we're switching profiles
    var currentDisplayedUsername = useSelector(function (state) {
        return state.rootReducer.dashboardReducer.viewing_username ||
            state.rootReducer.dashboardReducer.username;
    });
    // Local loading state for immediate feedback
    var _a = useState(false), isLocalLoading = _a[0], setIsLocalLoading = _a[1];
    // Check if we're switching to a different user (showing loading immediately)
    var isSwitchingProfiles = currentViewingUser &&
        currentDisplayedUsername &&
        currentViewingUser !== currentDisplayedUsername;
    // Also check if we have a viewUser from navigation state (immediate loading)
    var isNavigatingToNewUser = !!(state && state.viewUser && isLoading);
    // Additional check: if we're currently loading and have a viewUser, show loading
    // OR if we have a viewUser in navigation state and it's different from current displayed user
    var isLoadingWithViewUser = !!(state &&
        state.viewUser &&
        (isLoading || state.viewUser !== currentDisplayedUsername));
    // Track the last request to prevent race conditions
    var lastRequestRef = useRef("");
    // Debounced API call function
    var debouncedFetchData = useCallback(function (targetUser) {
        // Prevent duplicate requests
        if (lastRequestRef.current === targetUser) {
            return;
        }
        lastRequestRef.current = targetUser;
        dispatch(getCaseloads(targetUser));
        dispatch(getCaseloadsDashboard(targetUser));
    }, [dispatch]);
    if (!userToken) {
        // User has not logged in, no auth token
        // Redirect to Login
        useEffect(function () {
            navigate("/login");
        }, [navigate]);
    }
    else {
        // Now we know that the user is logged in. Perform the API calls
        useEffect(function () {
            var targetUser = state && state.viewUser ? state.viewUser : username;
            if (targetUser) {
                // Set local loading state immediately
                setIsLocalLoading(true);
                debouncedFetchData(targetUser);
            }
        }, [state, username, debouncedFetchData, isSwitchingProfiles]);
    }
    // Clear local loading when API call completes
    useEffect(function () {
        if (!isLoading) {
            setIsLocalLoading(false);
        }
    }, [isLoading]);
    // Also clear local loading when caseload data is received (backup clearing mechanism)
    useEffect(function () {
        if (caseload && isLocalLoading) {
            setIsLocalLoading(false);
        }
    }, [caseload, isLocalLoading]);
    // Additional safety check: Clear loading after a reasonable timeout (prevent stuck loading)
    useEffect(function () {
        if (isLocalLoading) {
            var timeout_1 = setTimeout(function () {
                setIsLocalLoading(false);
            }, 10000); // 10 second timeout
            return function () { return clearTimeout(timeout_1); };
        }
    }, [isLocalLoading]);
    var _b = useState(0), tabNumber = _b[0], setTabNumber = _b[1];
    var _c = useState((Array)), selectedData = _c[0], setSelectedData = _c[1];
    var handleSelectedData = function (data) {
        setSelectedData(data);
    };
    // Show info toast while deleting a user
    var _d = useState(null), toast = _d[0], setToast = _d[1];
    var lastShownDeleteResultRef = useRef(null);
    useEffect(function () {
        if (!deleteUsersResult ||
            lastShownDeleteResultRef.current === deleteUsersResult) {
            return;
        }
        lastShownDeleteResultRef.current = deleteUsersResult;
        var deleted = deleteUsersResult.deleted, blocked = deleteUsersResult.blocked;
        if (blocked.length > 0) {
            setToast(null);
            dispatch(showPopupModal(true, _jsxs(_Fragment, { children: [_jsx("h1", __assign({ className: "mb-7" }, { children: "Delete Data" })), deleted.length > 0 && (_jsxs("p", __assign({ className: "mb-3" }, { children: [deleted.length, " user(s) deleted successfully."] }))), _jsxs("div", __assign({ className: "font-medium not-italic set-line-height error" }, { children: [_jsxs("p", { children: [blocked.length, " user(s) could not be deleted because they still have users assigned to them:"] }), _jsx("ul", __assign({ className: "list-disc pl-5 mt-2" }, { children: blocked.map(function (b) { return (_jsxs("li", { children: [b.username, " (", b.count, " ", b.dependent_type, b.count !== 1 ? "s" : "", " still assigned)"] }, b.username)); }) })), _jsx("p", __assign({ className: "mt-2" }, { children: "Delete those users first, then try again." }))] }))] })));
        }
        else if (deleted.length > 0) {
            setToast({
                message: deleted.length === 1
                    ? "".concat(deleted[0], " deleted successfully.")
                    : "".concat(deleted.length, " users deleted successfully."),
                type: "success",
            });
        }
    }, [deleteUsersResult, dispatch]);
    useEffect(function () {
        if (toast && toast.type !== "info") {
            var timer_1 = setTimeout(function () { return setToast(null); }, 4000);
            return function () { return clearTimeout(timer_1); };
        }
    }, [toast]);
    // Calculate if we should show the loading overlay
    var isProfileSwitching = isLoading ||
        isSwitchingProfiles ||
        isNavigatingToNewUser ||
        isLocalLoading ||
        isLoadingWithViewUser;
    // Essential debug log for loading overlay issues
    if (isProfileSwitching) {
        console.log("🔄 ManageUsers: Loading overlay visible for user:", currentViewingUser);
    }
    // table sorting
    var _e = useState(null), sortConfig = _e[0], setSortConfig = _e[1];
    //export Data Modal
    var exportDataBody = (_jsxs(_Fragment, { children: [_jsx("h1", __assign({ className: "mb-7" }, { children: "Download Data" })), _jsx("p", { children: "Please click below to export the list of selected users. Jobseeker data will be exported as an .xlsx file and downloaded to your device." }), _jsx("div", __assign({ className: "pt-6" }, { children: _jsx(Button, { border: "none", onClick: function () {
                        dispatch(exportUsersData(selectedData));
                        dispatch(showPopupModal(false));
                    }, text: "Export", className: "mt-6" }) }))] }));
    var noJobseekersSelectedBody = (_jsxs(_Fragment, { children: [_jsx("h1", __assign({ className: "mb-7" }, { children: "Download Data" })), _jsx(ErrorMessage, { message: "Please select at least one jobseeker before exporting." })] }));
    //archive Data Modal
    var archiveDataBody = (_jsxs(_Fragment, { children: [_jsx("h1", __assign({ className: "mb-7" }, { children: "Archive Data" })), _jsx("p", { children: "Please click below to archive the list of selected users. Jobseeker data will be exported as an .xslx file." }), _jsx("div", __assign({ className: "pt-6" }, { children: _jsx(Button, { border: "none", onClick: function () {
                        dispatch(archiveUsersData(selectedData, username));
                        dispatch(showPopupModal(false));
                        setSelectedData([]);
                    }, text: "Archive", className: "mt-6" }) }))] }));
    //delete Data Modal
    var deleteDataBody = (_jsxs(_Fragment, { children: [_jsx("h1", __assign({ className: "mb-7" }, { children: "Delete Data" })), _jsx("p", { children: "Please click below to permanently delete the list of selected users and all of their associated data. This action cannot be undone." }), _jsx("div", __assign({ className: "pt-6" }, { children: _jsx(Button, { border: "none", onClick: function () {
                        dispatch(deleteUsersData(selectedData, username));
                        dispatch(showPopupModal(false));
                        setSelectedData([]);
                        setToast({
                            message: selectedData.length === 1
                                ? "Deleting user..."
                                : "Deleting ".concat(selectedData.length, " users..."),
                            type: "info",
                        });
                    }, text: "Delete", className: "mt-6" }) }))] }));
    var noUsersSelectedForDeleteBody = (_jsxs(_Fragment, { children: [_jsx("h1", __assign({ className: "mb-7" }, { children: "Delete Data" })), _jsx(ErrorMessage, { message: "Please select at least one user before deleting." })] }));
    // Check if we're in dev mode
    var isDevMode = function () {
        // Check if DEV_MODE is explicitly set to true in environment
        if (process.env.DEV_MODE === "true") {
            return true;
        }
        // Fallback methods to detect development mode
        // Check for development domain/hostname
        var hostname = window.location.hostname;
        if (hostname === "localhost" ||
            hostname === "127.0.0.1" ||
            hostname === "dev.myemploy.co.uk") {
            return true;
        }
        return false;
    };
    // Handle BLR recalculation
    var handleBlrRecalculation = function () {
        if (window.confirm("Are you sure you want to force BLR recalculation for all jobseekers? This may take a while.")) {
            dispatch(forceBlrRecalculation());
            // Refresh the caseload after recalculation
            setTimeout(function () {
                dispatch(getCaseloads(username));
                dispatch(getCaseloadsDashboard(username));
            }, 2000);
        }
    };
    // display tabs depending on logged in user type
    var getTabs = function (isSuperOrg, userType) {
        if (isSuperOrg) {
            switch (userType) {
                case "adviser":
                    return [];
                case "manager":
                    return ["Advisers"];
                case "superorg":
                    return ["Organisations", "Managers", "Advisers"];
                case "organisation":
                default:
                    return ["Managers", "Advisers"];
            }
        }
        else {
            switch (userType) {
                case "adviser":
                    return ["Customers"];
                case "manager":
                    return ["Advisers", "Customers"];
                case "superorg":
                    return ["Organisations", "Managers", "Advisers"];
                case "organisation":
                default:
                    return ["Managers", "Advisers", "Customers"];
            }
        }
    };
    var sortData = function (data, columnIndex, direction) {
        return __spreadArray([], data, true).sort(function (a, b) {
            var _a, _b;
            var aVal = a[columnIndex];
            var bVal = b[columnIndex];
            if (typeof aVal === 'boolean' || typeof bVal === 'boolean')
                return 0;
            if (typeof aVal === 'object' && (aVal === null || aVal === void 0 ? void 0 : aVal.type) === 'link')
                return 0;
            var aStr = typeof aVal === 'object' ? ((_a = aVal === null || aVal === void 0 ? void 0 : aVal.text) !== null && _a !== void 0 ? _a : '') : (aVal !== null && aVal !== void 0 ? aVal : '');
            var bStr = typeof bVal === 'object' ? ((_b = bVal === null || bVal === void 0 ? void 0 : bVal.text) !== null && _b !== void 0 ? _b : '') : (bVal !== null && bVal !== void 0 ? bVal : '');
            var emptyValues = ['-', ' - ', 'No data', 'No prediction', ''];
            if (emptyValues.includes(aStr) && emptyValues.includes(bStr))
                return 0;
            if (emptyValues.includes(aStr))
                return 1;
            if (emptyValues.includes(bStr))
                return -1;
            // Prediction %
            if (aStr.endsWith('%') && bStr.endsWith('%')) {
                var diff = parseFloat(aStr) - parseFloat(bStr);
                return direction === 'asc' ? diff : -diff;
            }
            // Time gap
            if (aStr.includes('Days') && bStr.includes('Days')) {
                var diff = parseInt(aStr) - parseInt(bStr);
                return direction === 'asc' ? diff : -diff;
            }
            // Questionnaire attempts
            if (aStr.includes('/') && bStr.includes('/')) {
                var diff = parseInt(aStr.split('/')[0]) - parseInt(bStr.split('/')[0]);
                return direction === 'asc' ? diff : -diff;
            }
            // Numeric strings
            var aNum = Number(aStr);
            var bNum = Number(bStr);
            if (!isNaN(aNum) && !isNaN(bNum)) {
                return direction === 'asc' ? aNum - bNum : bNum - aNum;
            }
            // Date strings
            var aDate = Date.parse(aStr);
            var bDate = Date.parse(bStr);
            if (!isNaN(aDate) && !isNaN(bDate)) {
                return direction === 'asc' ? aDate - bDate : bDate - aDate;
            }
            // Fallback: alphabetical
            return direction === 'asc'
                ? aStr.localeCompare(bStr)
                : bStr.localeCompare(aStr);
        });
    };
    var tableData = prepareForTable(caseload, viewing_user_type, tabNumber);
    if (sortConfig) {
        tableData = sortData(tableData, sortConfig.column, sortConfig.direction);
    }
    return (_jsxs("div", __assign({ className: "h-full" }, { children: [toast && (_jsxs("div", __assign({ className: "fixed top-6 right-6 z-50 px-4 py-3 rounded-lg text-sm font-medium shadow-lg flex items-center gap-2 ".concat(toast.type === "success"
                    ? "bg-green-100 text-green-800 border border-green-200"
                    : toast.type === "info"
                        ? "bg-blue-100 text-blue-800 border border-blue-200"
                        : "bg-red-100 text-red-800 border border-red-200") }, { children: [toast.type === "info" && (_jsx("span", { className: "inline-block h-3 w-3 rounded-full border-2 border-blue-800 border-t-transparent animate-spin" })), toast.message] }))), _jsx(NavBar, { viewing_user: viewing_user_type, logged_in_user: logged_in_user_type, viewing_username: username }), _jsxs("div", __assign({ className: "page-template-right", style: { position: "relative" } }, { children: [_jsx(LoadingOverlay, { isVisible: isProfileSwitching, message: state && state.viewUser
                            ? "Loading ".concat(state.viewUser, "'s data...")
                            : "Loading user data..." }), logged_in_user_type === viewing_user_type ? (_jsx(PageHeader, { title: "Manage Users" })) : (_jsx(PageHeader, { title: "Manage Users", backButton: "Back to Your Dashboard", onClick: function () {
                            navigate("/dashboard", {
                                state: { state: { viewUser: username } },
                            });
                        } })), logged_in_user_type !== "jobseeker" && (_jsx(ManageUsersStats, {})), _jsxs(Card, __assign({ multiLine: true, className: "!pt-4" }, { children: [_jsxs(GenericTab, __assign({ setStateCallback: setTabNumber, titles: getTabs(isSuperOrg, viewing_user_type) }, { children: [_jsx(Button, __assign({ onClick: function () {
                                            dispatch(showPopupModal(true, selectedData.length === 0
                                                ? noJobseekersSelectedBody
                                                : exportDataBody));
                                        }, buttonType: ButtonType.OutlinedPrimary, className: "w-full md:w-auto px-4 py-2 text-sm" }, { children: "Download Jobseeker Data" })), _jsx(Button, __assign({ onClick: function () {
                                            dispatch(showPopupModal(true, archiveDataBody));
                                        }, buttonType: ButtonType.OutlinedSecondary, className: "w-full md:w-auto px-4 py-2 text-sm" }, { children: "Archive Selected" })), _jsx(Button, __assign({ onClick: function () {
                                            dispatch(showPopupModal(true, selectedData.length === 0
                                                ? noUsersSelectedForDeleteBody
                                                : deleteDataBody));
                                        }, buttonType: ButtonType.OutlinedSecondary, className: "w-full md:w-auto px-4 py-2 text-sm" }, { children: "Delete Selected" })), _jsx(Button, __assign({ onClick: function () {
                                            dispatch(showPopupModal(true, _jsx(CreateUser, {})));
                                        }, className: "w-full md:w-auto px-4 py-2 text-sm" }, { children: "Create User" })), _jsxs(Button, __assign({ onClick: handleBlrRecalculation, buttonType: ButtonType.OutlinedSecondary, className: "w-full md:w-auto px-4 py-2 text-sm flex gap-2 items-center" }, { children: [_jsx("svg", __assign({ width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M21 10C21 10 18.995 7.26822 17.3662 5.63824C15.7373 4.00827 13.4864 3 11 3C6.02944 3 2 7.02944 2 12C2 16.9706 6.02944 21 11 21C15.1031 21 18.5649 18.2543 19.6482 14.5M21 10V4M21 10H15", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) })), "Refresh BLR"] }))] })), _jsx("div", { className: "tabs-hr" }), isLoading ? (_jsx("div", __assign({ className: "flex justify-center items-center py-8" }, { children: _jsxs("div", __assign({ className: "text-center" }, { children: [_jsx("div", { className: "animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto" }), _jsx("p", __assign({ className: "mt-2 text-gray-600" }, { children: "Loading data..." }))] })) }))) : (_jsx(TableCard, { headers: prepareHeader(viewing_user_type, tabNumber), data: tableData, sortConfig: sortConfig, onSort: function (columnIndex) {
                                    setSortConfig(function (prev) {
                                        return (prev === null || prev === void 0 ? void 0 : prev.column) === columnIndex
                                            ? { column: columnIndex, direction: prev.direction === 'asc' ? 'desc' : 'asc' }
                                            : { column: columnIndex, direction: 'asc' };
                                    });
                                }, currentTab: tabNumber, rowsPerPage: 10, showSearchBar: true, multiSelect: true, selectData: selectedData, handleSelectedData: handleSelectedData }))] })), logged_in_user_type !== "jobseeker" && (_jsx(PendingInvites, { refreshSignal: (createUserStatus === null || createUserStatus === void 0 ? void 0 : createUserStatus.status) === Status.Successful }))] }))] })));
}
